<div class="d-flex flex-direction" (click)="handleChildClick($event)">
  <span class="me-3 ac-ff account-number-label">Account Number</span>
  <div
    class="dropdown"
    (keyup.esc)="dropdownVisible = false"
    [ngbTooltip]="
      !isBansPresent
        ? 'No BANs associated with your account, please contact support.'
        : ''
    "
  >
    <button
      class="dropdown-select"
      (click)="toggleDropdown()"
      [ngClass]="{
        'dropdown-disabled': !isBansPresent,
        'margin-adjustment': ban
      }"
    >
      {{ ban || "Select BAN" }}
    </button>
    <div class="dropdown-menu" [ngClass]="{ show: dropdownVisible }">
      <div class="search-container">
        <input
          type="text"
          id="ban-dropdown-search"
          class="search-box"
          [ngClass]="{
            disable: (getBANs | keyvalue | json).length == 2 && !searchInput
          }"
          placeholder="Search..."
          [(ngModel)]="searchInput"
          tabindex="0"
          #searchInputRef
        />
        <span *ngIf="!searchInput" class="search-icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            width="20"
            height="20"
            viewBox="0 0 50 50"
          >
            <path
              d="M 21 3 C 11.601563 3 4 10.601563 4 20 C 4 29.398438 11.601563 37 21 37 C 24.355469 37 27.460938 36.015625 30.09375 34.34375 L 42.375 46.625 L 46.625 42.375 L 34.5 30.28125 C 36.679688 27.421875 38 23.878906 38 20 C 38 10.601563 30.398438 3 21 3 Z M 21 7 C 28.199219 7 34 12.800781 34 20 C 34 27.199219 28.199219 33 21 33 C 13.800781 33 8 27.199219 8 20 C 8 12.800781 13.800781 7 21 7 Z"
            ></path>
          </svg>
        </span>
        <button
          *ngIf="searchInput"
          class="clear-btn"
          (click)="clearSearchInput()"
          aria-label="Clear search input"
          [ngClass]="{
            disable: (getBANs | keyvalue | json).length == 2 && !searchInput
          }"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            width="20"
            height="20"
            viewBox="0 0 50 50"
          >
            <path
              d="M 9.15625 6.3125 L 6.3125 9.15625 L 22.15625 25 L 6.21875 40.96875 L 9.03125 43.78125 L 25 27.84375 L 40.9375 43.78125 L 43.78125 40.9375 L 27.84375 25 L 43.6875 9.15625 L 40.84375 6.3125 L 25 22.15625 Z"
            ></path>
          </svg>
        </button>
      </div>
      <ul class="dropdown-list" *ngIf="(getBANs | keyvalue | json).length != 2">
        <li
          *ngFor="let bans of getBANs | keyvalue; index as i"
          (click)="selectBan(bans.key)"
          tabindex="0"
          (keyup.enter)="selectBan(bans.key)"
          [ngClass]="{ selected: ban == bans.key }"
        >
          {{ bans.key }}
        </li>
      </ul>
      <div
        id="ban-dropdown-loader"
        *ngIf="(getBANs | keyvalue | json).length == 2 && !searchInput"
        class="api-loader"
      >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200">
          <circle
            fill="#070103"
            stroke="#070103"
            stroke-width="6"
            r="15"
            cx="40"
            cy="100"
          >
            <animate
              attributeName="opacity"
              calcMode="spline"
              dur="1.3"
              values="1;0;1;"
              keySplines=".5 0 .5 1;.5 0 .5 1"
              repeatCount="indefinite"
              begin="-.4"
            ></animate>
          </circle>
          <circle
            fill="#070103"
            stroke="#070103"
            stroke-width="6"
            r="15"
            cx="100"
            cy="100"
          >
            <animate
              attributeName="opacity"
              calcMode="spline"
              dur="1.3"
              values="1;0;1;"
              keySplines=".5 0 .5 1;.5 0 .5 1"
              repeatCount="indefinite"
              begin="-.2"
            ></animate>
          </circle>
          <circle
            fill="#070103"
            stroke="#070103"
            stroke-width="6"
            r="15"
            cx="160"
            cy="100"
          >
            <animate
              attributeName="opacity"
              calcMode="spline"
              dur="1.3"
              values="1;0;1;"
              keySplines=".5 0 .5 1;.5 0 .5 1"
              repeatCount="indefinite"
              begin="0"
            ></animate>
          </circle>
        </svg>
      </div>
      <div
        *ngIf="(getBANs | keyvalue | json).length == 2 && searchInput"
        class="no-results"
      >
        <span>No Results Found</span>
      </div>
    </div>
  </div>
</div>
